// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1793847580010
      var cssReload = require("D:/work/admin/datacenter_web/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  